import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import formService from "../../../services/form.service";

const initialValues = {
  title: "",
  description: "",
  isActive: true,
};
const schema = Yup.object().shape({
    title: yupSchema.title128,
});
const form = [
  {
    _type: "textField",
    name: "title",
    label: "عنوان",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "description",
    multiline: true,
    rows: 10,
    label: "توضیحات",
    autoFocus: false,
  },
  {
    _type: "switch",
    name: "isActive",
    label: "فعال",
  },
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {

    console.log(model)
    let op;
    if (data?.id) {
      op = await formService.editForm(data.id, model);
    } else {
      op = await formService.createForm(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "فرم",
        data,
        schema,
        initialValues: {
            ...initialValues,
            ...data
        },
        handleSubmit,
        form,
      }}
    />
  );
}
